export default "__VITE_ASSET__C8P$9Uvg__"